import React, { useEffect } from "react";
import { graphql } from "gatsby";
import Product from "../sections/Product";
import ProductDetails from "../sections/ProductDetails";
import ProductHowToUse from "../sections/ProductHowToUse";
import ProductIcons from "../sections/ProductIcons";
import ProductReviews from "../sections/ProductReviews";
import ProductRecommendations from "../sections/ProductRecommendations";
import Layout from "../layouts/default";
import { Helmet } from "react-helmet";
import { trackViewItem } from "../utils/analytics";

export const query = graphql`
  query Accessory($id: String) {
    contentfulAccessories(id: { eq: $id }) {
      __typename
      slug
      shopifyId
      contentful_id
      description {
        raw
      }
      id
      features
      care
      images {
        fluid(maxWidth: 900) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
        file {
          url
        }
      }
      detailsImage {
        fluid(maxWidth: 900) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
        file {
          url
        }
      }
      name
      variants {
        id
        name
        individual {
          shopifyId
          price
          sku
        }
      }
    }
    allContentfulProduct(filter: { id: { ne: $id } }) {
      nodes {
        __typename
        id
        name
        slug
        shortDescription {
          shortDescription
        }
        productImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        useImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        variants {
          individual {
            shopifyId
            price
          }
          subscription {
            shopifyId
            price
          }
          volumeOrSize
        }
      }
    }
    allContentfulProductSet(filter: { id: { ne: $id } }) {
      nodes {
        __typename
        id
        name
        slug
        customizable
        shortDescription {
          shortDescription
        }
        setItem {
          price
        }
        productImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        hoverImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        variants {
          individual {
            shopifyId
            price
          }
          subscription {
            shopifyId
            price
          }
          volumeOrSize
        }
      }
    }
  }
`;

export default function ProductTemplate({ data, location }) {
  const { allContentfulProduct, allContentfulProductSet } = data;

  // Merge products and sets, shuffle, and then grab first 2 for 'you might like' section
  const allProducts = allContentfulProduct.nodes.concat(
    allContentfulProductSet.nodes
  );
  const shuffledProducts = allProducts
    .sort(() => 0.5 - Math.random())
    .slice(0, 2);

  useEffect(() => {
    trackViewItem({
      item_id: atob(
        data.contentfulAccessories.variants[0].individual.shopifyId
      ).replace("gid://shopify/ProductVariant/", ""),
      item_name: data.contentfulAccessories.name,
      price: data.contentfulAccessories.variants[0].individual.price,
      currency: "USD",
      klavyio_url: window.location.href,
      klavyio_img: data.contentfulAccessories.images[0].file.url,
    });
  }, []);

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>{data.contentfulAccessories.name}</title>
        <meta
          property="og:image"
          content={data.contentfulAccessories.images[0].file.url}
        />
      </Helmet>
      <Product product={data.contentfulAccessories} />
      <ProductDetails product={data.contentfulAccessories} />
      {/* <ProductReviews product={data.contentfulAccessories} /> */}
      <ProductRecommendations
        products={shuffledProducts}
      ></ProductRecommendations>
    </Layout>
  );
}
